import CheckIcon from '@mui/icons-material/Check';
import { Avatar, colors, Stack, Typography, useTheme } from '@mui/material';
import type { StepProps } from '/@/types/bayer/step';

function Step({
    index,
    active,
    name,
    caption,
    subSteps,
    summary,
    onClick,
    disabled,
    isSidebarHeader,
    sidebarHeaderIcon,
}: StepProps) {
    const theme = useTheme();
    return (
        <Stack
            alignItems='center'
            spacing={2}
            py='20px'
            paddingLeft={2}
            paddingRight={3}
            borderBottom={'1px solid lightgray'}
            sx={{ textAlign: 'left', cursor: !active || isSidebarHeader ? 'pointer' : 'default' }}
            onClick={!active || isSidebarHeader ? onClick : undefined}
            backgroundColor={isSidebarHeader && colors.grey[200]}
        >
            <Stack direction='row' alignItems='center' justifyContent='space-between' width='100%'>
                <Stack direction='row' alignItems='center' spacing={3}>
                    <Avatar
                        sx={{
                            width: 25,
                            height: 25,
                            mr: 2,
                            fontWeight: 600,
                            border: active && !disabled ? 'none' : '1px solid lightgray',
                            color: active && !disabled ? 'white' : theme.palette.primary[50],
                            background: active && !disabled ? theme.palette.primary.main : 'white',
                        }}
                    >
                        {index}
                    </Avatar>
                    <Stack>
                        <Typography
                            variant='h6'
                            sx={{
                                color: active && !disabled ? theme.palette.primary.main : theme.palette.primary[50],
                            }}
                        >
                            {name || ''}
                        </Typography>
                        <Typography
                            variant='caption'
                            sx={{
                                color: active && !disabled ? theme.palette.primary.main : theme.palette.primary[50],
                            }}
                        >
                            {caption}
                        </Typography>
                    </Stack>
                </Stack>
                {!active && !isSidebarHeader && <CheckIcon color='success' sx={{ width: 20, height: 20 }} />}
                {isSidebarHeader && sidebarHeaderIcon}
            </Stack>
            {summary && (
                <Stack pl='41px' pr={0} width='100%'>
                    {summary}
                </Stack>
            )}
            {subSteps && (
                <Stack px='60px' spacing={1} width='100%'>
                    {subSteps.map((step, i) => (
                        <Typography variant='subtitle1' key={i}>
                            {step}
                        </Typography>
                    ))}
                </Stack>
            )}
        </Stack>
    );
}

export default Step;
